<template>
  <ZigzagServiceLayout
    mainTitle="Telemedicine: Accessible Care Wherever You Are"
    mainDescription="Experience high-quality medical care from the comfort of your home. Our telehealth platform connects you with experienced professionals for consultations, follow-ups, and specialized treatments."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'TelemedicineContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'TELEMEDICINE',
          title: 'General Primary Care',
          subtitle: 'Accessible medical care from the comfort of your home.',
          paragraphs: [
            "Our primary care telehealth services provide you with direct access to experienced healthcare professionals for a wide range of non-emergency medical needs. Whether you're dealing with a common illness, need a prescription refill, or require follow-up care, our virtual clinic offers a convenient and efficient solution.",
            "Through secure video consultations, we can assess your symptoms, provide accurate diagnoses, and develop personalized treatment plans, all without the need to travel to a physical office."
          ],
          list: [
            "Consultations for common illnesses like colds, flu, and infections",
            "Routine health check-ups and preventative care guidance",
            "Management of stable chronic conditions",
            "Prescription renewals and medication management"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        },
        {
          label: 'METABOLIC HEALTH',
          title: 'Weight Management',
          subtitle: 'Comprehensive, evidence-based approach to achieving a healthy weight.',
          paragraphs: [
            "Integrated weight management and metabolic health programs provide a comprehensive, evidence-based approach to achieving a healthy weight and improving overall metabolic function. These programs differ from traditional diets by incorporating medical oversight, advanced technology for monitoring, personalized nutritional and behavioral guidance, and, when clinically indicated, safe, physician-supervised pharmacological therapies.",
            "A cornerstone of modern programs is the use of telehealth and digital tools to enhance access and accountability. Virtual monitoring leverages technology to track patient progress and provide continuous support and accountability outside of scheduled appointments."
          ],
          list: [
            "<strong>Medical Supervision:</strong> Comprehensive assessment including history, evaluation, and goal setting.",
            "<strong>Virtual Monitoring:</strong> Remote patient monitoring tracking progress and providing continuous support.",
            "<strong>Nutrition Counseling:</strong> Customized meal planning, behavioral coaching, and education.",
            "<strong>Physician-Supervised Therapies:</strong> Safe, FDA-approved weight-loss medications prescribed when indicated."
          ],
          image: '/images/services/weight-management-telehealth.png'
        },
        {
          label: 'SPECIALIZED CARE',
          title: "Men's & Women's Health",
          subtitle: 'Personalized hormone optimization and wellness strategies.',
          paragraphs: [
            "Hormonal imbalances can significantly impact your quality of life, affecting energy levels, mood, metabolism, and sexual health. Our telehealth platform provides a discreet and comfortable environment to discuss these sensitive issues with our specialized providers.",
            "We offer comprehensive evaluations for both men and women, including medical history review and the coordination of necessary lab work to accurately assess your hormone levels and develop a tailored treatment plan."
          ],
          list: [
            "Testosterone replacement therapy (TRT) consultations for men",
            "Hormone replacement therapy (HRT) and menopause support for women",
            "Management of symptoms like fatigue, weight gain, and low libido",
            "Ongoing monitoring and dosage adjustments via virtual visits"
          ],
          image: '/images/services/hormone-therapy-telehealth.png'
        },
        {
          label: 'WELLNESS & SUPPORT',
          title: 'Mental Health & Lifestyle',
          subtitle: 'Compassionate care for your emotional well-being.',
          paragraphs: [
            "Mental health is a vital component of your overall health, and our telehealth services make it easier than ever to prioritize your emotional well-being. From managing daily stressors to addressing more complex behavioral health challenges, our compassionate team is here to support you.",
            "We provide a safe, non-judgmental virtual space to discuss your concerns, learn effective coping strategies, and work towards a more balanced and fulfilling life."
          ],
          list: [
            "Counseling for stress management, anxiety, and depression",
            "Behavioral coaching to support healthy lifestyle changes",
            "Strategies for improving sleep quality and building resilience",
            "Integration with our weight management and nutrition programs"
          ],
          image: '/images/services/mental-health-telehealth.png'
        }
      ]
    };
  }
};
</script>
